import { useState } from 'react'

import { useRouter } from 'next/router'

import type { PortfolioCardItemProps } from '~/components/blocks/PortfolioCard/PortfolioCard'
import type { PortfolioCollectionVariant } from '~/components/blocks/PortfolioItemDetails/PortfolioItemDetails'

import usePortfolioInfoWindow from './usePortfolioInfoWindow'

const useInventoryParam = (
  items: PortfolioCardItemProps[],
  variant: PortfolioCollectionVariant
) => {
  const [windowOpen, setWindowOpen] = useState<boolean>(false)
  const router = useRouter()
  const { openInfoWindow } = usePortfolioInfoWindow()
  const localTicketID = localStorage.getItem('ticketIdToOpen')

  if ((!router?.query.ticketid && !localTicketID) || windowOpen) return

  const ticketId = router.query.ticketid ? router.query.ticketid : localTicketID

  const ticketRequested = items.filter((item: any) => {
    return item.ticketId == ticketId
  })

  if (ticketRequested.length > 0) {
    setWindowOpen(true)
    openInfoWindow(ticketRequested[0], variant, undefined, false)
    if (localTicketID) localStorage.removeItem('ticketIdToOpen')
  }
}

export default useInventoryParam
